import moment from 'moment'
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap'

const ModalVersionHistory = ({ isOpen, toggle, schemaData }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      data-testid="map-schema-version-history-modal"
    >
      <ModalHeader toggle={toggle}>
        Riwayat Versi: {schemaData?.name}
      </ModalHeader>
      <ModalBody>
        {schemaData?.versionHistory && schemaData.versionHistory.length > 0 ? (
          <div className="table-responsive">
            <Table bordered hover size="sm">
              <thead className="table-light">
                <tr>
                  <th style={{ width: '10%' }}>Versi</th>
                  <th style={{ width: '40%' }}>Komposisi</th>
                  <th style={{ width: '20%' }}>Dibuat Oleh</th>
                  <th style={{ width: '20%' }}>Tanggal</th>
                  <th style={{ width: '10%' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {schemaData.versionHistory.map((version, index) => (
                  <tr key={index} data-testid={`map-schema-version-row-${version.version}`}>
                    <td className="text-center">
                      <span className="badge bg-secondary">
                        v{version.version}
                      </span>
                    </td>
                    <td>
                      <ul className="mb-0" style={{ paddingLeft: '20px' }}>
                        {version.items?.map((item, idx) => (
                          <li key={idx}>
                            {item.quantity}x {item.itemName} ({item.itemCode})
                          </li>
                        ))}
                      </ul>
                    </td>
                    <td>{version.createdBy || '-'}</td>
                    <td>
                      {version.createdAt
                        ? moment(version.createdAt).format('DD MMM YYYY, HH:mm')
                        : '-'}
                    </td>
                    <td className="text-center">
                      {version.version === schemaData.currentVersion ? (
                        <span className="badge bg-success">Aktif</span>
                      ) : (
                        <span className="badge bg-secondary">History</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <p className="text-center text-muted my-4">
            Belum ada riwayat versi untuk schema ini
          </p>
        )}
      </ModalBody>
    </Modal>
  )
}

export default ModalVersionHistory
